import { createFileRoute } from "@tanstack/react-router";
import HashListsPage from "src/components/app/HashListPage/HashListsPage";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { getHashListsPageData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/hash-lists/")({
  loader: projectLoader((projectId) => getHashListsPageData({ data: projectId })),
  component: PortalHashListsPage,
});

function PortalHashListsPage() {
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => <HashListsPage projectId={data?.projectId} initialLists={data?.initialLists} />}
    </DeferredLoaderData>
  );
}
